// src/lib/supabaseClient.js
// Browser Supabase client, used ONLY for sign-in (Supabase Auth).
// All data reads and writes still go through ApptNote's own API, which checks
// the signed-in session on every request.
//
// The anon key is designed to be public. Every table has row-level security
// switched on, so this key cannot read or write ApptNote data by itself.
//
// Required Vercel environment variables:
//   REACT_APP_SUPABASE_URL
//   REACT_APP_SUPABASE_ANON_KEY

import { createClient } from '@supabase/supabase-js';

// Accept the URL with or without a trailing /rest/v1 (Supabase shows both forms).
const url = (process.env.REACT_APP_SUPABASE_URL || '')
  .trim()
  .replace(/\/rest\/v1\/?$/, '')
  .replace(/\/+$/, '');
const anonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

export const supabase = url && anonKey
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
        storageKey: 'apptnote-auth',
      },
    })
  : null;

// Returns a fresh access token for API calls, refreshing it if needed.
export async function getAccessToken() {
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  return data?.session?.access_token ?? null;
}

// Clears the session and any locally cached profile details.
export async function signOut() {
  try {
    if (supabase) await supabase.auth.signOut();
  } catch (err) {
    // Signing out locally is what matters; ignore network errors.
  }
  ['apptnote_session_token', 'apptnote_journey_stage'].forEach((k) => {
    try { localStorage.removeItem(k); } catch (e) { /* ignore */ }
  });
}
